import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Booking } from '../booking';

interface ApprovedModalProps {
  show: boolean;
  onHide: () => void;
  approvedDetails: Booking[];
  approvedModalError: string | null;
  statusColors: { [key: string]: string };
  handleViewClick: (booking: Booking) => void;
  handleEditClick: (booking: Booking) => void; // Added prop for edit functionality
}

const ApprovedModal: React.FC<ApprovedModalProps> = ({
  show,
  onHide,
  approvedDetails,
  approvedModalError,
  statusColors,
  handleViewClick,
  handleEditClick,
}) => {
  const [isServiceManagerOrDepartmentHead, setIsServiceManagerOrDepartmentHead] = useState<boolean>(true);;

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Approved Bookings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {approvedModalError && (
          <div className="alert alert-danger" role="alert">
            {approvedModalError}
          </div>
        )}
        {!approvedModalError && approvedDetails.length === 0 && (
          <Alert role="alert" variant="info">
            No approved bookings found.
          </Alert>
        )}
        {!approvedModalError && approvedDetails.length > 0 && (
          <div className="table-responsive">
            <table className="table table-striped table-nowrap">
              <thead className="table-primary">
                <tr>
                  <th>ID</th>
                  <th>Employee Number</th>
                  <th>Name</th>
                  <th>Status</th>         
                  <th>Departure Time</th>
                  <th>Priority</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {approvedDetails.map((booking) => (
                  <tr key={booking.id}>
                    <td>{booking.id}</td>
                    <td>{booking.user?.empNumber || 'N/A'}</td>
                    <td>{booking.user?.name || 'N/A'}</td>
                    <td>
                      <span className={statusColors[booking.status] || 'badge bg-secondary'}>
                        {booking.status || 'N/A'}
                      </span>
                    </td>
                     <td>
                      {booking.departureTime
                        ? new Date(Number(booking.departureTime)).toLocaleString()
                        : 'N/A'}
                    </td>
                    <td>{booking.priority || 'N/A'}</td>
                    <td>
                      <div className="hstack gap-2 fs-3">
                        <Link
                          to="#"
                          className="btn btn-icon btn-sm btn-soft-secondary rounded-pill"
                          onClick={() => handleViewClick(booking)}
                          title="View Booking"
                        >
                          <i className="feather-eye" />
                        </Link>
                        {isServiceManagerOrDepartmentHead && (
                          <Link
                            to="#"
                            className="btn-icon btn-sm btn-soft-info rounded-pill"
                            onClick={() => handleEditClick(booking)}
                            title="Edit Booking"
                          >
                            <i className="feather-edit" />
                          </Link>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApprovedModal;